<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="طابعات B2338 وB2442 وM1242 وMS321 وMS421">
     طابعات B2338 وB2442 وM1242 وMS321 وMS421
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ar" title="معلومات السلامة">
     معلومات السلامة
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href=".html#d0e23" title="مصطلحات متفق عليها">
      مصطلحات متفق عليها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="safety-power-cord-topic.html#d0e42" title="بيانات عن المنتج">
      بيانات عن المنتج
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ar" title="التعرف على الطابعة">
     التعرف على الطابعة
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ar" title="العثور على معلومات عن الطابعة">
      العثور على معلومات عن الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ar" title="تحديد موقع للطابعة">
      تحديد موقع للطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printer-configurations-topic.html#printer-configurations_ar" title="مواصفات الطابعة">
      مواصفات الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="attaching-cables-topic.html#attaching-cables_ar" title="توصيل الكبلات">
      توصيل الكبلات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-control-panel-topic.html#using-control-panel_ar" title="استخدام لوحة التحكم">
      استخدام لوحة التحكم
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ar" title="فهم حالة زر الطاقة وضوء المؤشر">
      فهم حالة زر الطاقة وضوء المؤشر
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_ar" title="تحميل الورق والوسائط الخاصة">
     تحميل الورق والوسائط الخاصة
    </a>
   </p>
   <div id="divd0e736">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_ar" title="تعيين حجم الوسائط الخاصة ونوعها">
      تعيين حجم الوسائط الخاصة ونوعها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_ar" title="تهيئة إعدادات الورق العام">
      تهيئة إعدادات الورق العام
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="loading-trays-topic.html#loading-trays_ar" title="تحميل الأدراج">
      تحميل الأدراج
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_ar" title="تحميل وحدة التغذية المتعددة الأغراض">
      تحميل وحدة التغذية المتعددة الأغراض
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_ar" title="ربط الأدراج">
      ربط الأدراج
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_ar" title="دعامة الورق">
     دعامة الورق
    </a>
   </p>
   <div id="divd0e929">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_ar" title="أحجام الورق المدعومة">
      أحجام الورق المدعومة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_ar" title="أنواع الورق المدعومة">
      أنواع الورق المدعومة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_ar" title="أوزان الورق المدعومة">
      أوزان الورق المدعومة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_ar" title="الورق غير المقبول">
      الورق غير المقبول
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_ar" title="استخدام الورق المُعاد تدويره">
      استخدام الورق المُعاد تدويره
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ar" title="الطباعة">
     الطباعة
    </a>
   </p>
   <div id="divd0e1536">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ar" title="الطباعة من كمبيوتر">
      الطباعة من كمبيوتر
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1562" title="الطباعة من جهاز محمول">
      الطباعة من جهاز محمول
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_ar" title="طباعة قائمة عينات الخطوط">
      طباعة قائمة عينات الخطوط
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ar" title="فهم قوائم الطابعة">
     فهم قوائم الطابعة
    </a>
   </p>
   <div id="divd0e1706">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="menus-map-topic.html#menus-map_ar" title="خريطة القوائم">
      خريطة القوائم
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="preferences-topic.html#d0e1885" title="جهاز">
      جهاز
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="layout-topic.html#d0e2851" title="Print (طباعة)">
      Print (طباعة)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="tray-configuration-topic.html#d0e3828" title="ورق">
      ورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="network-overview-topic.html#d0e4065" title="Network/Ports (الشبكة/المنافذ)">
      Network/Ports (الشبكة/المنافذ)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="menu-settings-page-topic.html#d0e5545" title="Reports (التقارير)">
      Reports (التقارير)
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="troubleshooting-group.html#d0e5674" title="استكشاف الأخطاء وإصلاحها">
      استكشاف الأخطاء وإصلاحها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_ar" title="طباعة صفحة إعدادات القوائم">
      طباعة صفحة إعدادات القوائم
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ar" title="تأمين الطابعة">
     تأمين الطابعة
    </a>
   </p>
   <div id="divd0e5728">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="locating-security-slot-topic.html#locating-security-slot_ar" title="تحديد موقع فتحة الأمان">
      تحديد موقع فتحة الأمان
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ar" title="مسح ذاكرة الطابعة">
      مسح ذاكرة الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ar" title="استعادة إعدادات المصنع الافتراضية">
      استعادة إعدادات المصنع الافتراضية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_ar" title="بيان الذاكرة">
      بيان الذاكرة
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ar" title="صيانة الطابعة">
     صيانة الطابعة
    </a>
   </p>
   <div id="divd0e5900">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e5905" title="شبكة الاتصال">
      شبكة الاتصال
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="cleaning-printer-topic.html#cleaning-printer_ar" title="تنظيف الطابعة">
      تنظيف الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="ordering-supplies.html#ordering-supplies_ar" title="طلب الأجزاء والمستلزمات">
      طلب الأجزاء والمستلزمات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="replacing-toner-cartridge-topic.html#d0e6526" title="استبدال الأجزاء والمستلزمات">
      استبدال الأجزاء والمستلزمات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="moving-the-printer.html#moving-the-printer_ar" title="تحريك الطابعة">
      تحريك الطابعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="configuring-power-save-mode-settings-topic.html#d0e6725" title="توفير الطاقة والورق">
      توفير الطاقة والورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="recycling-lexmark-products-topic.html#d0e6873" title="إعادة التدوير">
      إعادة التدوير
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_ar" title="التخلص من انحشار الورق">
     التخلص من انحشار الورق
    </a>
   </p>
   <div id="divd0e6927">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="avoiding-jams-topic.html#avoiding-jams_ar" title="تجنب انحشار الورق">
      تجنب انحشار الورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_ar" title="تحديد أماكن انحشار الورق">
      تحديد أماكن انحشار الورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_ar" title="انحشار الورق في الباب A">
      انحشار الورق في الباب A
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_ar" title="انحشار الورق عند الباب الخلفي">
      انحشار الورق عند الباب الخلفي
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_ar" title="انحشار الورق في الحاوية القياسية">
      انحشار الورق في الحاوية القياسية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_ar" title="انحشار الورق بوحدة الطباعة على الوجهين">
      انحشار الورق بوحدة الطباعة على الوجهين
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_ar" title="انحشار الورق في الأدراج">
      انحشار الورق في الأدراج
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_ar" title="انحشار الورق داخل وحدة التغذية متعددة الأغراض">
      انحشار الورق داخل وحدة التغذية متعددة الأغراض
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ar" title="استكشاف الأخطاء وإصلاحها">
     استكشاف الأخطاء وإصلاحها
    </a>
   </p>
   <div id="divd0e7203">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e7206" title="مشاكل الاتصال بالشبكة">
      مشاكل الاتصال بالشبكة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e7353" title="مشاكل المستلزمات">
      مشاكل المستلزمات
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e7499" title="مشاكل تغذية الورق">
      مشاكل تغذية الورق
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-blank-or-white-pages-topic.html#d0e7885" title="مشاكل الطباعة">
      مشاكل الطباعة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ar" title="الاتصال بخدمة دعم العملاء">
      الاتصال بخدمة دعم العملاء
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-and-migrating-chapter.html#upgrading-and-migrating-chapter_ar" title="الترقية والترحيل">
     الترقية والترحيل
    </a>
   </p>
   <div id="divd0e10237">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="available-internal-options-topic.html#d0e10240" title="الأجهزة">
      الأجهزة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="installing-printer-software-topic.html#d0e10400" title="برنامج">
      برنامج
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e10476" title="البرامج الثابتة">
      البرامج الثابتة
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ar" title="إشعارات">
     إشعارات
    </a>
   </p>
   <div id="divd0e10545">
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e10548" title="معلومات عن المنتج">
      معلومات عن المنتج
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e10565" title="إشعار الإصدار">
      إشعار الإصدار
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#trademarks_ar" title="العلامات التجارية">
      العلامات التجارية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#licensing-notices_ar" title="إشعارات الترخيص">
      إشعارات الترخيص
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#noise-emission-levels_ar" title="مستويات انبعاث التشويش">
      مستويات انبعاث التشويش
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e10659" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#product-disposal_ar" title="التخلص من المنتج">
      التخلص من المنتج
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ar" title="إرجاع خراطيش Lexmark بغرض إعادة استخدامها أو إعادة تدويرها">
      إرجاع خراطيش Lexmark بغرض إعادة استخدامها أو إعادة تدويرها
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ar" title="إشعار الحساسية للكهرباء الاستاتيكية">
      إشعار الحساسية للكهرباء الاستاتيكية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#energy-star_ar" title="برنامج ENERGY STAR">
      برنامج ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#temperature-information_ar" title="معلومات درجة الحرارة">
      معلومات درجة الحرارة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#laser-notice_ar" title="إشعار الليزر">
      إشعار الليزر
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#power-consumption_ar" title="استهلاك الطاقة">
      استهلاك الطاقة
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#d0e10895" title="الإشعارات التنظيمية الخاصة بالمنتجات اللاسلكية">
      الإشعارات التنظيمية الخاصة بالمنتجات اللاسلكية
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#modular-component-notice_ar" title="إشعار المكون النمطي">
      إشعار المكون النمطي
     </a>
    </p>
    <p class="toc-2-style" style="
margin-right:14pt;
margin-left:0pt;
">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ar" title="التعرض لإشعاع تردد الراديو">
      التعرض لإشعاع تردد الراديو
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue